(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vat-toggle"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'candy-show-vat';

    function isOn() {
      try {
        return window.localStorage.getItem(STORAGE_KEY) === '1';
      } catch (err) {
        return false;
      }
    }

    function setOn(on) {
      try {
        window.localStorage.setItem(STORAGE_KEY, on ? '1' : '0');
      } catch (err) {}
    }

    function apply(on) {
      document.querySelectorAll('[data-vat-root]').forEach(function (root) {
        root.classList.toggle('is-vat-on', on);
      });
      document.querySelectorAll('[data-vat-toggle]').forEach(function (button) {
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        var onLabel = button.getAttribute('data-label-on');
        var offLabel = button.getAttribute('data-label-off');
        if (onLabel && offLabel) {
          button.setAttribute('aria-label', on ? onLabel : offLabel);
        }
      });
    }

    function init() {
      apply(isOn());
      document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-vat-toggle]');
        if (!button) return;
        var next = button.getAttribute('aria-pressed') !== 'true';
        setOn(next);
        apply(next);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
